import { useCallback, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { buildManifestOpenPath } from "./manifestsV3DrawerNavigation";

/**
 * Owns the URL wiring for `ManifestsV3`'s row-click drawer: the manifest drawer
 * (path segment `processedManifestId`, read by the caller via
 * `useSelectedIdInUrl`).
 */
export function useManifestsV3RowDrawers(processedManifestId: string | undefined) {
  const navigate = useNavigate();
  const location = useLocation();

  // Read through a ref so `openManifest` keeps its identity as the URL changes;
  // a new identity per keystroke rebuilds the grid's column definitions.
  const locationRef = useRef({
    pathname: location.pathname,
    search: location.search,
    processedManifestId,
  });
  locationRef.current = {
    pathname: location.pathname,
    search: location.search,
    processedManifestId,
  };

  const openManifest = useCallback(
    /** `section` deep-links the drawer to one of its sections; omit for the top. */
    (manifestId: string, section?: string) => {
      const current = locationRef.current;
      navigate(
        buildManifestOpenPath({
          pathname: current.pathname,
          search: current.search,
          currentManifestId: current.processedManifestId,
          manifestId,
          section,
        }),
        { replace: !!current.processedManifestId, preventScrollReset: true }
      );
    },
    [navigate]
  );

  return { openManifest };
}
